export enum QAPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export const QA_PRIORITIES: QAPriority[] = [
  QAPriority.LOW,
  QAPriority.MEDIUM,
  QAPriority.HIGH,
]

export const getQAPriorityMeta = (priority: QAPriority, t: (k: string) => string) => {
  switch (priority) {
    case QAPriority.LOW:
      return {
        label: t('project.views.QuestionAnswerAdd.priority.low'),
        fullLabel: t('project.views.QuestionAnswerAdd.priority.lowFull'),
        icon: 'keyboard_double_arrow_down',
        iconColor: 'icon-info',
        locatorValue: 'qa-priority-low',
      }

    case QAPriority.HIGH:
      return {
        label: t('project.views.QuestionAnswerAdd.priority.high'),
        fullLabel: t('project.views.QuestionAnswerAdd.priority.highFull'),
        icon: 'keyboard_double_arrow_up',
        iconColor: 'icon-danger',
        locatorValue: 'qa-priority-high',
      }

    case QAPriority.MEDIUM:
    default:
      return {
        label: t('project.views.QuestionAnswerAdd.priority.medium'),
        fullLabel: t('project.views.QuestionAnswerAdd.priority.mediumFull'),
        icon: 'equal',
        iconColor: 'icon-warning',
        locatorValue: 'qa-priority-medium',
      }
  }
}
